export default __webpack_public_path__ + "static/media/video2.ffe79f00.png";